// Notes in light theme, dark will be inverted

/**
 * 'Real' color palettes with multiple shades
 */
export enum Color {
  primary = 'primary',
  danger = 'danger',
  warning = 'warning',
  success = 'success',
  info = 'info',
}

export enum ColorShade {
  foreground = 'foreground',
  softest = 'softest',
  softer = 'softer',
  soft = 'soft',
  semiSoft = 'semiSoft',
  color = 'color',
  semiStrong = 'semiStrong',
  strong = 'strong',
  stronger = 'stronger',
  strongest = 'strongest',
}

export type ColorPalette = {
  [key in ColorShade]: string
}

export type ColorPaletteDefinition = Partial<ColorPalette> & Pick<ColorPalette, ColorShade.color>

/**
 * Technical palette used for color mixing
 */
export enum AbsoluteColor {
  min = 'min', // Deepest for color mixing
  max = 'max', // Highest for color mixing
}
export type AbsolutePalette = {
  [key in AbsoluteColor]: string
}

/**
 * Base palette for all surfaces and components: from background to texts
 */
export enum BaseColor {
  min = 'min', // Absolute minimum (exceptional cases)
  shade_0 = 'shade_0', // Deepest parts: inputs, contrast background
  shade_10 = 'shade_10', // Background
  shade_15 = 'shade_15',
  shade_20 = 'shade_20', // Background alternative
  shade_30 = 'shade_30', // Borders
  shade_40 = 'shade_40',
  shade_50 = 'shade_50',
  shade_60 = 'shade_60', // Dim text
  shade_70 = 'shade_70',
  shade_80 = 'shade_80', // Text
  shade_90 = 'shade_90',
  shade_100 = 'shade_100', // Highest parts: all kind of text/icons highlights
  max = 'max', // Absolute maximum (exceptional cases)
  surfaceBg = 'surfaceBg', // Floating elements surfaces (modals, tooltips)
  overlay = 'overlay', // Primary overlay color on top of base (modal overlay)
}

export type BaseColorPalette = {
  [key in BaseColor]: string
}

export type BaseColorPaletteDefinition = Partial<BaseColorPalette> & Pick<BaseColorPalette, BaseColor.shade_0 | BaseColor.shade_100>

export type Opacity = 10 | 20 | 25 | 50 | 70 | 75 | 90

/**
 * All the colors we have in the theme
 */
export interface Palette {
  absolute: AbsolutePalette

  base: BaseColorPalette
  primary: ColorPalette

  danger: ColorPalette
  warning: ColorPalette
  success: ColorPalette
  info: ColorPalette
}

/**
 * Minimum colors required for building theme
 */
export type PaletteDefinition = {
  absolute: AbsolutePalette

  base: BaseColorPaletteDefinition
  primary: ColorPaletteDefinition

  danger: ColorPaletteDefinition
  warning: ColorPaletteDefinition
  success: ColorPaletteDefinition
  info: ColorPaletteDefinition
}
